export default __webpack_public_path__ + "static/media/profile.54093143.jpg";